import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPenToSquare, faXmark } from "@fortawesome/sharp-solid-svg-icons";
import React, { useState, useEffect, KeyboardEvent, createRef } from "react";
import styles from './Editable.module.scss';
import { useClickOutside, useMergedRef } from "@mantine/hooks";

export default function Editable(props: {readonly?:boolean, centre?: boolean, value:string, prompt:string, placeholder:string, onSave: (x:string)=>void})
{
  const [isEditing, setEditing] = useState(false);
  const [value, setValue]=useState(props.value);

    let childRef = createRef<HTMLInputElement>();
    const useClickOutsideRef = useClickOutside(() => {setEditing(false); props.onSave(value);});
    const mergedRef = useMergedRef(childRef, useClickOutsideRef);

  /* 
    using use effect, when isEditing state is changing, check whether it is set to true, if true, then focus on the reference element
  */ 
  useEffect(() => {
    if (isEditing && childRef.current) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>)
  {
    const { key } = event;
    const keys = ["Escape", "Tab", "Enter"];

    if (keys.indexOf(key) > -1)
     {

        if (key=='Escape')
        {
            setValue(props.value);
        }
        else
        {
            props.onSave(value);
        }
      setEditing(false);
      event.preventDefault();
      event.stopPropagation();
    }
};

let align : any = props.centre?"center":"left";

let containerStyle : React.CSSProperties = {width:"100%", marginBottom:3, display:"flex", height:26, flexWrap:"nowrap", justifyContent:props.centre?"center":"flex-start", alignItems:"center"};

if (props.readonly)
{
    return <div style={containerStyle}><span style={{whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>{props.value}</span></div>
}

function startEditing()
{
    setEditing(true);
}

return <>
<div style={containerStyle}>
{isEditing?<div style={{display:"flex", marginLeft:10, marginRight:10, flexWrap:"nowrap", flexGrow:1, justifyContent:props.centre?"center":"flex-start", alignItems:"center"}}>
    <input style={{flexGrow:1, flexShrink:1,textAlign:align}} ref={mergedRef} type='text' value={value} placeholder={props.placeholder} onKeyDown = {(e)=>handleKeyDown(e)} onChange={(x)=>setValue(x.target.value)}/>
    <FontAwesomeIcon icon={faCheck} className={styles.icon} onClick={()=>{setEditing(false); props.onSave(value);}}/>
    <FontAwesomeIcon icon={faXmark} className={styles.icon} onClick={()=>{setEditing(false); setValue(props.value);}}/>
    </div>:
<><span style={{opacity:0.7, cursor:"pointer", textDecoration:"underline dotted", textAlign:align, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}} onClick={()=>startEditing()}>{props.value?props.value:props.prompt}</span>
<FontAwesomeIcon icon={faPenToSquare} className={styles.icon} onClick={()=>startEditing()}/>
</>
}
</div>
</>
}
